<template>
  <div>
    <contact-us></contact-us>
  </div>
</template>

<script>
import ContactUs from '@/components/layout/ContactUs.vue';

export default {
  name: 'ContactPage',
  components: {
    ContactUs
  }
}
</script>

<style scoped>

</style>